module.exports = __webpack_public_path__ + "static/media/MA.68c6eafb.svg";